import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './PanelWrapper.css';
import cx from 'classnames';

// Component
import HomeSlider from "../../../Home/HomeSlider";

// Locale
import messages from '../../../../locale/jsonMessages';

import ManageListingsQuery from './ManageListingsProfile.graphql';

import { withQuery } from '../../../../hoc/withGraphql';

class PanelWrapper extends Component {

	static propTypes = {
		data: PropTypes.array.isRequired,
		formatMessage: PropTypes.any,
	};
	static defaultProps = {
		ManageListingsData: {
			ManageListingsProfile: [],
			loading: true
		}
	}

	constructor(props) {
		super(props);
	}

	componentDidUpdate() {
		const { ManageListingsData: { ManageListingsProfile }, setStateVariable } = this.props;
		if (ManageListingsProfile && ManageListingsProfile.length > 0) {
			setStateVariable({ isProfileData: true })
		}
	}

	render() {
		const { ManageListingsData: { loading, ManageListingsProfile }, firstName } = this.props;
		return (
			<>
				{
					ManageListingsProfile && ManageListingsProfile.length > 0 && <>
						<div className={s.lineCss}></div>
						<h3 className={cx(s.sliderHeader, s.space2)}>{ManageListingsProfile.length > 1 ? <FormattedMessage {...messages.vehiclesLabel} /> : <FormattedMessage {...messages.vehicleLabel} />}</h3>
						<div >
							{
								!loading && <HomeSlider
									data={ManageListingsProfile}
									fromPage={"viewProfile"}
									hideHeading={true}
									isViewProfile
								/>
							}
						</div>
					</>
				}
			</>
		);
	}
}

export default compose(
	injectIntl,
	withStyles(s),
	withQuery(ManageListingsQuery, {
		name: 'ManageListingsData',
		options: (props) => ({
			variables: {
				userId: props.userId,
			},
			fetchPolicy: 'network-only',
			ssr: false
		})
	}),
)(PanelWrapper);